var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[(_vm.visible)?_c('div',{ref:"overlay",staticClass:"sf-overlay",class:[_vm.staticClass, _vm.className],on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }